import useTableRestQuery from "@/directory/hooks/useTableRestQuery/useTableRestQuery";
import { API_BASE_URL } from "@/api/api.config";

const DEFAULT_SORT = [
  { id: "status", desc: false },
  { id: "provider", desc: false },
  { id: "name", desc: false },
];

const useUserClassroomGet = (id, params = {}, pageSize = 30) => {
  const url = `${API_BASE_URL}/api/v3/user/${id}/classroom/`;

  const skip = !id;

  const [classrooms, fetchClassrooms, controls] = useTableRestQuery(
    url,
    pageSize,
    DEFAULT_SORT,
    params,
    skip,
  );

  return {
    data: classrooms.data,
    loading: classrooms.loading,
    error: classrooms.error,
    controls,
    fetchClassrooms,
  };
};

export default useUserClassroomGet;
